module.exports = __webpack_public_path__ + "img/logo-safari.5f90e78f.png";